<template>
  <div class="upgrade-reasons">
    <div class="container">
      <div class="upgrade-reasons-content">
        <h1 class="text-center text-sm md:text-base mb-4 text-support-light">
          Upgrade Required
        </h1>

        <ul class="upgrade-reason-list">
          <li
            v-for="(upgradeReason, i) in upgradeReasons"
            :key="i"
            class="upgrade-reason-card"
          >
            <p v-if="$get(upgradeReason, 'title')" class="upgrade-reason-title">
              {{ $get(upgradeReason, "title") }}
            </p>

            <p v-if="$get(upgradeReason, 'info')" class="upgrade-reason-info">
              {{ $get(upgradeReason, "info") }}
            </p>
          </li>
        </ul>

        <p
          v-if="canDownload"
          class="text-center text-xs italic mb-0 text-support-lighter font-sans mt-4"
        >
          &hellip;you now have two options
          <span class="roman" role="img" aria-label="finger pointing down"
            >👇</span
          >
        </p>
      </div>
      <!-- .upgrade-reasons-content -->
    </div>
    <!-- .container -->
  </div>
</template>

<script>
export default {
  name: "UpgradeReasons",
  props: {
    canDownload: {
      type: Boolean,
      default: true,
    },
    upgradeRequiredReasons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    upgradeReasons() {
      const upgradeReasons = {
        CUSTOM_ELEMENTS_USED: {
          title: "You've customized the template  🖼",
          info:
            "To send or download you need to either upgrade or remove the custom images.",
        },
        EMAILS_SENT_EXCEEDED: {
          title: "You've sent all your emails already 🙈",
          info:
            "Performing this send will exceed the email count on your current plan.",
        },
        PROMO_BRANDING_REMOVED: {
          title: "You removed the Promo.ai branding from the footer ✂️",
          info:
            "If you want to avoid upgrading re-enable the branding section.",
        },
      };

      return this.upgradeRequiredReasons
        .filter((reason) => reason !== "FREE_PLAN")
        .map((reason) => upgradeReasons[reason]);
    },
  },
};
</script>

<style scoped>
.upgrade-reasons {
  @apply mb-8 bg-grey-lightest py-6 border border-grey-lighter;

  @screen lg {
    margin-bottom: 60px;
  }
}

.upgrade-reasons-content {
  @apply max-w-sm;

  @screen sm {
    @apply mx-auto;
  }
}

.upgrade-reason-list {
  @apply mb-0;

  li:last-child {
    @apply mb-0;
  }
}

.upgrade-reason-card {
  @apply mb-4 text-grey-light mb-2;
}

.upgrade-reason-title {
  @apply mx-auto mb-1 font-lato text-brand;
  font-size: 12px;

  @screen md {
    @apply text-xs;
  }
}

.upgrade-reason-info {
  @apply mx-auto m-0 text-support-light;
  font-size: 11px;

  @screen md {
    font-size: 12px;
  }
}
</style>
